import React from 'react';
import useHttp from 'app/utils/hooks/use-http';
import { StylesConfig, ValueType } from 'react-select';

import MFormAddressInputView from './MFormAddressInput.view';

import { ILatLng } from 'app/models/latLng';
import { IMFormAdrressValue } from './MFormAddressInput.model';

interface Props {
  className?: string;
  placeholder?: string;
  name: string;
  value: IMFormAdrressValue | null;
  customStylesSelect?: StylesConfig<{ label: string; value: string }, false>;
  disabled?: boolean;
  onChange: (value: IMFormAdrressValue | null) => void;
  onBlur?: (event: React.FocusEvent<HTMLElement>) => void;
  onMenuClose?: () => void;
}

const MFormAddressInput: React.FC<Props> = (props: React.PropsWithChildren<Props>) => {
  const http = useHttp();

  const fetchCoordsAndEmit = (value: ValueType<{ label: string; value: string }, false>) => {
    if (!value) {
      props.onChange(null);
      return;
    }

    http.google.getCoords(value.value).then((coord: ILatLng) => {
      props.onChange({ name: value.value, lat: coord.latitude, lng: coord.longitude });
    });
  };

  return (
    <MFormAddressInputView
      className={props.className}
      placeholder={props.placeholder}
      name={props.name}
      value={props.value?.name || null}
      customStylesSelect={props.customStylesSelect}
      disabled={props.disabled}
      onChange={fetchCoordsAndEmit}
      onBlur={props.onBlur}
      onMenuClose={props.onMenuClose}
    ></MFormAddressInputView>
  );
};

MFormAddressInput.displayName = 'MFormAddressInput';
MFormAddressInput.defaultProps = {};

export default MFormAddressInput;
